import { Component, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';

import BreadcrumbComponent from '@/application/breadcrumb/components/breadcrumb/breadcrumb.vue';
import { AuthenticatedUser, FetchAuthenticatedUserQuery } from '@/application/authentication/types';
import { UserAction } from '@/application/types';
import SnackbarComponent from '../../../snackbar/snackbar.component.vue';
import AppHeader from '../app-header/app-header.vue';
import LocalStorageHint from '../local-storage-hint/local-storage-hint.vue';

const authenticationState = namespace('authentication');

@Component({
  components: {
    AppHeader,
    BreadcrumbComponent,
    SnackbarComponent,
    LocalStorageHint,
  },
})
export default class App extends Vue {

  @authenticationState.State
  styleAlias!: string;

  @authenticationState.State
  courseTitle!: string;

  @authenticationState.State
  user!: AuthenticatedUser;

  @authenticationState.State
  isAuthenticated!: boolean;

  @authenticationState.Action
  fetchAuthenticatedUser!: UserAction<FetchAuthenticatedUserQuery>;

  actionsSubscription: any;

  get styleClasses(): string[] {
    const styleClasses = [
      'default',
    ];

    if (this.$route.name) {
      styleClasses.push(this.$route.name);
    }

    if (this.$route.meta?.styleClass) {
      styleClasses.push(this.$route.meta.styleClass);
    }

    return styleClasses;
  }

  destroyed() {
    this.actionsSubscription();
  }

}
